import React from 'react';
import {Link} from 'react-router-dom';
import ArrFunnelChart from '../../../components/common/arr-funnel-chart/ArrFunnelChart';
import {Box} from '@mui/material';
import '../Demo.scss';

const FunnelDemo: React.FC = () => {
  return (
    <Box className="demo-page funnel-demo">
      <h1>Funnel Chart</h1>

      <Link to="/demo" className="link">
        Return
      </Link>

      <Box>
        <ArrFunnelChart
          widgetData={{
            released: 1598,
            notReviewed: 1573,
            reviewed: 25,
            responsive: 47,
            privileged: 8,
            totalProduced: 0,
          }}
          className="demo-end-to-end-widget"
        />

        <ArrFunnelChart
          widgetData={{
            released: 0,
            notReviewed: 0,
            reviewed: 0,
            responsive: 0,
            privileged: 0,
            totalProduced: 0,
          }}
          className="demo-end-to-end-widget"
        />
      </Box>
    </Box>
  );
};

export default FunnelDemo;
